import * as api from '../../../../api';

export async function verifiCredentials(uuid, values) {
    const { url } = await api.post(`/azure/signin`, {
        ...values,
        connector_uuid: uuid,
    });
    return url;
}

export async function loadGroups(uuid) {
    const { data } = await api.get(`/azure/groups`, {
        connector_uuid: uuid,
    });
    return data;
}
